<template>
  <a-modal v-model:visible="visible"  width="1100px">
    <template #title>
      <span>材料成本</span>
      <small>（对比采购材料来自报价方案设定的材料清单）</small>
    </template>
    <hmd-table-action class="pt0">
      <template #left>
        <div class="ub">
          <div>报价方案材料总价：{{$filters.formatMoney(baojiaTotal)}} </div>
          <div style="margin-left:100px;">已产生费用：{{$filters.formatMoney(caigouTotal)}} </div>
        </div>
      </template>
    </hmd-table-action>
    <a-table
    :tableLayout="'fixed'"
      row-key="materialNo1"
      :bordered="true"
      :columns="columns"
      :data-source="lists"
      :pagination="false"
      :rowClassName="rowClassFn"
    >
      <template #index="{ index }">
        <span>{{ index+1}}</span>
      </template>
      <template #totalPrice1="{ record }">
        {{ record.totalPrice1!=='-'?$filters.formatMoney(record.totalPrice1):'-' }}
      </template>
      <template #totalPrice2="{ record }">
        {{ record.totalPrice2!=='-'?$filters.formatMoney(record.totalPrice2):'-' }}
      </template>
    </a-table>
    <template #footer >
      <div class="ub ub-pe fw" >
        <a-button v-if="showFooter" @click="visible=false">取消</a-button>
        <a-button type="primary" v-if="showFooter" @click="submit">继续保存采购订单</a-button>
      </div>
    </template>

  </a-modal>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, watch ,computed,ref,onMounted} from "vue";
import { ContractSimpleListReq, ProfileService } from "@/views/contract";
import {notifyEmitter} from "@/utils/emitter"
import NP from "number-precision/src/index";
import {isNumber} from "@/utils"
export default defineComponent({
  isGlobal: true,
  name: "CostWarning",
  props: {
    showFooter:{
      type:Boolean,
      default:false
    },
    tableData:{
      type:Array,
      default:()=>{
        return []
      }
    },
  },
  emits: ["update:value", "change","submit"],
  setup(props, { emit }) {
    const visible = ref(false)
    const lists = computed(()=>{
      return props.tableData;
    })
    const baojiaTotal=ref(0)
    const caigouTotal = ref(0)

    onMounted(()=>{
      notifyEmitter.all.delete("emit-notify")
      notifyEmitter.on('emit-notify',(flg)=>{
        visible.value=flg
        baojiaTotal.value=0;
        caigouTotal.value=0;
        // console.log( baojiaTotal.value,caigouTotal.value)
        props.tableData.forEach((item:any)=>{
          let totalPrice1=0
          let totalPrice2=0
          if(!isNumber(item.totalPrice2)){
            totalPrice2=0;
          }else{
            totalPrice2 = item.totalPrice2
          }
          if(!isNumber(item.totalPrice1)){
            totalPrice1=0;
          }else{
            totalPrice1 = item.totalPrice1
          }
          baojiaTotal.value = NP.plus(baojiaTotal.value,totalPrice1)
          caigouTotal.value=NP.plus(caigouTotal.value,totalPrice2)
          item.materialNo1= item.materialNo1||'-'
          item.materialNo2= item.materialNo2||'-'
          item.materialName1= item.materialName1||'-'
          item.materialName2= item.materialName2||'-'
          item.count1= item.count1||'-'
          item.count2= item.count2||'-'
          item.totalPrice1= item.totalPrice1||'-'
          item.totalPrice2= item.totalPrice2||'-'
        })
      })
    })
    const rowClassFn = (record,index)=>{
      if(record.count2>record.count1 || record.totalPrice2>record.totalPrice1 || (record.totalPrice2>0&&!isNumber(record.totalPrice1))){
        return {
          style:{
            'background-color':'#f9dfe3',
            'color':'#dc3950'
          }
        }
      }
    }
    const submit=()=>{
      emit('submit')
    }
    const columns = [
      {
        title: "序号",
        dataIndex: "index",
        align:"center",
        width: 80,
        slots: { customRender: "index" },
      },
      {
        title:"项目报价方案材料清单",
        width:510,
        children:[
          {
            title:"材料编号",
            dataIndex: 'materialNo1',
            key: 'materialNo1',
            width: 100,
          },
          {
            title:"材料名称",
            dataIndex: 'materialName1',
            key: 'materialName1',
            width: 160,
            ellipsis:true
          },
          {
            title:"数量",
            dataIndex: 'count1',
            key: 'count1',
            width: 90,
          },
          {
            title:"合价",
            dataIndex: 'totalPrice1',
            key: 'totalPrice1',
            width: 100,
            slots: { customRender: "totalPrice1" },
          },
        ]
      },
      {
        title:"项目累计采购材料清单",
        width:510,
        children:[
          {
            title:"材料编号",
            dataIndex: 'materialNo2',
            width: 110,
            slots: { customRender: "materialNo2" },
            customCell:rowClassFn
          },
          {
            title:"材料名称",
            dataIndex: 'materialName2',
            width: 160,
            ellipsis:true,
            slots: { customRender: "materialName2" },
            customCell:rowClassFn
          },
          {
            title:"数量",
            dataIndex: 'count2',
            width: 90,
            slots: { customRender: "count2" },
            customCell:rowClassFn
          },
          {
            title:"合价",
            dataIndex: 'totalPrice2',
            width: 100,
            slots: { customRender: "totalPrice2" },
            customCell:rowClassFn
          },
        ]
      }
    ]

    return {
      visible,
      columns,
      lists,
      rowClassFn,
      baojiaTotal,
      caigouTotal,
      submit
    };
  },
});
</script>
<style lang="less" scoped>
  .cl-red{
    background-color: darkred;
  }
</style>